import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Form from "./pages/Form";
import WelcomePage from "./pages/WelcomePage";
import Closed from "./pages/Closed";
import Closed2 from "./pages/Closed2";
import End from "./pages/End"

const ScrollToTopOnRouteChange = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App = () => (
  <BrowserRouter>
    {/* Scroll to top on route change */}
    <ScrollToTopOnRouteChange />

    <Routes>
      <Route path="/:id/:id2" element={<Closed />} />
      <Route path="/2025/:id/:id2" element={<Closed2 />} />
      <Route path="2025/form/:id/:id2" element={<Closed2 />} />
      <Route path="2025/end/:id/:id2" element={<Closed2 />} />
    </Routes>
  </BrowserRouter>
);

export default App;
